import type { OysterIcon } from "@oysterhr/icons"
import { createContext, useContext } from "react"
import type { AlertProps, AlertVariation } from "./types"

export const AlertContext = createContext<AlertProps>({ variation: "gray" })
export function useAlertContext() {
  return useContext(AlertContext)
}

export const ICON_VARIATION: Record<AlertVariation, OysterIcon> = {
  success: "CheckCircle",
  error: "WarningCircle",
  info: "InfoCircle",
  warning: "WarningTriangle",
  gray: "WarningOctagon",
}

export const STYLES_VARIATION: Record<AlertVariation, string> = {
  success: "bg-success-lighten-100",
  error: "bg-error-lighten-100",
  info: "bg-info-lighten-100",
  warning: "bg-warning-lighten-100",
  gray: "bg-gray-100",
}

export const ICON_STYLES_VARIATION: Record<AlertVariation, string> = {
  success: "text-success-base",
  error: "text-error-base",
  info: "text-info-base",
  warning: "text-warning-base",
  gray: "text-gray-400",
}
